module.exports = __webpack_public_path__ + "media/images/placeholders/praevention-2c240eceab1b1226158fe3d2a172d503.jpg";